export enum ProyectoTareasEstado {
  Planificada,
  EnProceso,
  Realizada,
  Anulada,
}

export const ProyectoTareasEstadoLabels: {
  [key in ProyectoTareasEstado]: string;
} = {
  [ProyectoTareasEstado.Planificada]: 'Planificada',
  [ProyectoTareasEstado.EnProceso]: 'EnProceso',
  [ProyectoTareasEstado.Realizada]: 'Realizada',
  [ProyectoTareasEstado.Anulada]: 'Anulada',
};

export const getProyectoTareasEstado = () => {
  return Object.values(ProyectoTareasEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ProyectoTareasEstadoLabels[id as ProyectoTareasEstado],
    }));
};

export const colorMapping: { [key in ProyectoTareasEstado]: string } = {
  [ProyectoTareasEstado.Planificada]: '#22c55e',
  [ProyectoTareasEstado.EnProceso]: '#70BDFF',
  [ProyectoTareasEstado.Realizada]: '#FF0000',
  [ProyectoTareasEstado.Anulada]: 'orange',
};
